import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCode2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m15.75 8.75 3.5 3.25-3.5 3.25M8.25 8.75 4.75 12l3.5 3.25"
    />
  </svg>
);
export default SvgCode2;
